import ModoContabilidadVentasConstant from 'constants/modosContabilidadVentas'

const getValoresIniciales = dataCompania => {
  return {
    _idDepartamento: dataCompania._idDepartamento || '',
    _idProvincia: dataCompania._idProvincia || '',
    _idDistrito: dataCompania._idDistrito || '',
    anexo: dataCompania.anexo || '',
    claveSOL: dataCompania.claveSOL || '',
    direccion: dataCompania.direccion || '',
    flagAprobacionOrdenCompra: dataCompania.flagAprobacionOrdenCompra || false,
    montoAprobacionOrdenCompra: dataCompania.montoAprobacionOrdenCompra ?? '',
    flagAprobacionCajaChica: dataCompania.flagAprobacionCajaChica || false,
    flagCodigoBarra: dataCompania.flagCodigoBarra || false,
    flagCodigoSunat: dataCompania.flagCodigoSunat || false,
    flagCentroCostoVenta: dataCompania.flagCentroCostoVenta || false,
    flagContabilidad: dataCompania.flagContabilidad || false,
    flagEnvioAutomatico: dataCompania.flagEnvioAutomatico || false,
    flagGrifo: dataCompania.flagGrifo || false,
    flagInventario: dataCompania.flagInventario || false,
    flagLoteProductos: dataCompania.flagLoteProductos || false,
    flagConsumoEnCompra: dataCompania.flagConsumoEnCompra || false,
    flagLogo: dataCompania.flagLogo || false,
    flagMarcas: dataCompania.flagMarcas || false,
    flagMostrarRazonSocial: dataCompania.flagMostrarRazonSocial || false,
    flagOrdenCompraEnVentas: dataCompania.flagOrdenCompraEnVentas || false,
    flagPermitirIngresoSoloConOC: dataCompania.flagPermitirIngresoSoloConOC || false,
    flagPermitirVentaSinStock: dataCompania.flagPermitirVentaSinStock || false,
    flagPlacaEnVentas: dataCompania.flagPlacaEnVentas || false,
    flagTasaPorTarjeta: dataCompania.flagTasaPorTarjeta || false,
    flagVendedorEnVentas: dataCompania.flagVendedorEnVentas || false,
    mailingMail: dataCompania.mailingMail || '',
    mailingPass: dataCompania.mailingPass || '',
    mailingService: dataCompania.mailingService || '',
    modoContabilidadVentas: dataCompania.modoContabilidadVentas || ModoContabilidadVentasConstant.EN_LINEA,
    nombreComercial: dataCompania.nombreComercial || '',
    razonSocial: dataCompania.razonSocial || '',
    ruc: dataCompania.ruc || '',
    tasaPorTarjeta: dataCompania.tasaPorTarjeta || '',
    tasaValidacionCosto: dataCompania.tasaValidacionCosto || '',
    ubigeo: dataCompania.ubigeo || '',
    urbanizacion: dataCompania.urbanizacion || '',
    usuarioSOL: dataCompania.usuarioSOL || ''
  }
}

export default getValoresIniciales
